import React from 'react';
import { Spinner, Text } from '@cubeyou-team/hx-react-components';

import { NotLoggedLayout } from '../../../../../../layouts';
import translations from '../../../../../../lang';

const { FREE_TRIAL } = translations['en-US'];

export const TrialSignupLoader = () => (
  <NotLoggedLayout>
    <div className="flex min-h-screen w-full items-center justify-center px-4 pb-8">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="medium" variant="error" />
        <Text variant="light" size="xheadline">
          {FREE_TRIAL.LOADING.MESSAGE}
        </Text>
      </div>
    </div>
  </NotLoggedLayout>
);
